import { Dialog, DialogContent, IconButton } from "@mui/material";
import { FiExternalLink, FiInstagram, FiPhone, FiX } from "react-icons/fi";

const MenuIntro = ({ open, restaurantData, profileImage, onClose }) => {
  const settings = restaurantData?.restaurantSettings || {};
  const phone = restaurantData?.phone;
  const instagram = restaurantData?.instagram || settings.socialLinks?.instagram;
  const address = settings.showAddress === false ? "" : (settings.address || restaurantData?.address);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs" dir="rtl" PaperProps={{ className: "rounded-2xl" }}>
      <DialogContent className="relative text-center">
        <IconButton onClick={onClose} aria-label="بستن اطلاعات رستوران" className="!absolute !left-3 !top-3"><FiX /></IconButton>
        <img src={profileImage} alt={`نشان ${restaurantData?.name || "رستوران"}`} className="mx-auto mt-3 h-20 w-20 rounded-full border border-gray-100 object-cover" />
        <h2 className="mt-3 text-xl font-black text-gray-900">{restaurantData?.name}</h2>
        {settings.welcomeText && <p className="mt-3 text-sm leading-7 text-gray-600">{settings.welcomeText}</p>}
        {address && <p className="mt-3 text-sm text-gray-500">{address}</p>}
        <div className="mt-5 flex justify-center gap-2">
          {phone && <a href={`tel:${phone}`} className="inline-flex min-h-11 items-center gap-2 rounded-xl border border-gray-200 px-4 text-sm font-bold text-gray-700"><FiPhone /> تماس</a>}
          {instagram && <a href={instagram.startsWith("http") ? instagram : `https://instagram.com/${instagram.replace(/^@/, "")}`} target="_blank" rel="noreferrer" className="inline-flex min-h-11 items-center gap-2 rounded-xl border border-gray-200 px-4 text-sm font-bold text-gray-700"><FiInstagram /> اینستاگرام <FiExternalLink /></a>}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MenuIntro;
